import React from "react"
import { css } from 'emotion'

const SectionVivo = () => {
  return (
    <section
      className={css`
        background-color: #fff;
        padding: 10px 40px 10px 40px;
        text-align: center;
      `}
    >
      <h3
        className={css`
          color: #00aae4;
          font-weight: 300;
          font-size: 3.4rem;
        `}
      >
        ¡Hagamos que la distancia sea
        <br />
        irrelevante!
      </h3>

      <h3>Transmisión en vivo</h3>
      <p>
        Las personas importantes para vos podrán seguir el acto en vivo por el
        canal YouTube de IES
      </p>

      <a className="boton"
        href="https://www.youtube.com/user/IESVID"
        target="_blank"
        rel="noopener noreferrer"
      >
        Seguir EN VIVO
      </a>
    </section>
  )
}

export default SectionVivo
